import React, { useEffect, useState } from "react"
import firebase from "gatsby-plugin-firebase"
import { navigate } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Layout from "../components/Layout"
import Seo from "../components/Frontend/Seo"
import Logo from "../components/Frontend/Logo"
import { ButtonColor } from "../components/Frontend/Button"
import { numberWithCommas } from "../utils/helper"
import { Row, Col, Progress, Spin, Button, notification } from "antd"
import styled from "styled-components"

const PageContainer = styled.div`
  max-width: 652px;
  margin: 40px auto 80px auto;
  background-color: #fff;
  .heroContent {
    margin: 0 auto 40px auto;
    text-align: center;
    .title {
      font-family: "Prompt", sans-serif;
      font-weight: 600;
      font-size: 40px;
      line-height: 50px;
      color: #212b3c;
      margin-bottom: 20px;
    }
    .text {
      font-family: "Prompt", sans-serif;
      font-weight: 500;
      font-size: 32px;
      line-height: 48px;
      color: #000000;
      margin-bottom: 0;
    }
  }
  .progressWrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin: 30px 0;
    p {
      font-family: "Prompt", sans-serif;
      font-weight: 400;
      font-size: 16px;
      line-height: 40px;
      color: #575757;
    }
    .ant-progress-inner,
    .ant-progress-bg {
      border-radius: 0;
    }
    .ant-progress-bg {
      height: 52px !important;
    }
    .ant-progress-outer {
      max-width: calc(100% - 32px);
    }
    .ant-progress-text {
      font-family: "Prompt", sans-serif;
      font-weight: 500;
      font-size: 16px;
      color: #212b3c;
    }
  }
  .courseWrapper {
    margin-bottom: 60px;
    h1 {
      font-family: "Prompt", sans-serif;
      font-weight: 400;
      font-size: 22px;
      line-height: 38px;
      color: #575757;
      margin-bottom: 10px;
    }
    h3 {
      font-family: "Prompt", sans-serif;
      font-weight: 600;
      font-size: 40px;
      line-height: 60px;
      color: #00b017;
      margin-bottom: 10px;
    }
    h4 {
      font-family: "Prompt", sans-serif;
      font-weight: 400;
      font-size: 28px;
      line-height: 38px;
      color: #575757;
      margin-bottom: 0;
    }
  }
  /*p.normal {
    font-family: "Prompt", sans-serif;
    font-weight: 400;
    font-size: 18px;
    line-height: 1.75;
    color: #575757;
  }
  p.special {
    font-family: "Prompt", sans-serif;
    font-weight: 500;
    font-size: 24px;
    color: #575757;
    margin-bottom: 10px;
    span {
      font-family: "Prompt", sans-serif;
      font-weight: 600;
      color: #00b017;
    }
  }*/
  .courseDetails {
    .title {
      font-family: "Prompt", sans-serif;
      font-weight: 600;
      font-size: 32px;
      line-height: 38px;
      color: #575757;
      margin-bottom: 0;
    }
    .text {
      font-family: "Prompt", sans-serif;
      font-weight: 400;
      font-size: 18px;
      color: #575757;
      line-height: 38px;
      margin-bottom: 40px;
    }
    .text1 {
      font-family: "Prompt", sans-serif;
      font-weight: 400;
      font-size: 26px;
      color: #575757;
      line-height: 38px;
      margin-bottom: 40px;
    }
    h3.color1 {
      font-family: "Prompt", sans-serif;
      font-weight: 500;
      font-size: 40px;
      color: #00b017;
      line-height: 50px;
      margin-bottom: 40px;
    }
    h3.color2 {
      font-family: "Prompt", sans-serif;
      font-weight: 600;
      font-size: 32px;
      color: #00b017;
      line-height: 38px;
      margin-bottom: 40px;
    }
    p.special {
      font-family: "Prompt", sans-serif;
      font-weight: 600;
      font-size: 26px;
      color: #575757;
      line-height: 38px;
      margin-bottom: 10px;
      span {
        color: #00b017;
      }
    }
    p.gift {
      font-family: "Prompt", sans-serif;
      font-weight: 600;
      font-size: 20px;
      color: #575757;
      line-height: 38px;
      margin-bottom: 0;
    }
  }
  .imageTop {
    margin-top: 20px;
    margin-bottom: 40px;
  }
  .imageBottom {
    margin-top: 0px;
    margin-bottom: 60px;
  }
  .backgroundWrapper {
    padding: 30px;
    margin-top: 40px;
    margin-bottom: 60px;
    background: #212b3c;
    border-radius: 5px;
    .title {
      font-family: "Prompt", sans-serif;
      font-weight: 500;
      font-size: 24px;
      color: #fff;
      line-height: 36px;
      margin-bottom: 20px;
    }
    .text {
      font-family: "Prompt", sans-serif;
      font-weight: 400;
      font-size: 18px;
      color: #fff;
      line-height: 32px;
      margin-bottom: 30px;
      a {
        padding-left: 5px;
        color: #00b017;
        text-decoration: underline;
      }
    }
  }
  .linkButton {
    min-width: 180px;
    width: 100%;
    height: 58px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    font-family: "Prompt", sans-serif;
    font-weight: 500;
    font-size: 18px;
    color: #fff;
    background: #00b017;
    border-radius: 5px;
    text-decoration: none;
    transition: all 0.25s ease;
    &:hover {
      color: #fff;
      text-decoration: none;
    }
  }
  .itemWrapper {
    margin-top: 50px;
    margin-bottom: 50px;
    .enabled {
      padding: 30px;
      background: #212b3c;
      border-radius: 5px;
      p {
        font-family: "Prompt", sans-serif;
        font-weight: 400;
        font-size: 18px;
        color: #fff;
        line-height: 1.75;
        &.hilight {
          font-family: "Prompt", sans-serif;
          font-weight: 500;
          font-size: 18px;
        }
      }
      .price {
        font-family: "Prompt", sans-serif;
        font-weight: 500;
        font-size: 18px;
        color: #fff;
        strike {
          font-weight: 600;
          font-size: 26px;
          color: #00b017;
          line-height: 40px;
          padding-right: 10px;
        }
        span {
          font-weight: 600;
          font-size: 40px;
          color: #00b017;
          line-height: 60px;
          padding-right: 5px;
        }
      }
    }
  }
  @media only screen and (max-width: 320px) {
  }
`
const PortfolioWrapper = styled.div`
  margin-bottom: 40px;
  .title {
    font-family: "Prompt", sans-serif;
    font-weight: 400;
    font-size: 26px;
    color: #575757;
    line-height: 38px;
    margin-bottom: 40px;
  }
  .portfolioItem {
    position: relative;
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      &:hover {
        .overlay {
          opacity: 1;
          background-color: rgba(252, 26, 88, 0.75);
        }
        .itemTitle {
          opacity: 1;
        }
        .gatsby-image-wrapper {
          transform: scale(1.05, 1.05);
        }
      }
    }
    .overlay {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      background-color: transparent;
      z-index: 2;
      transition-delay: 150ms;
      transition: opacity 0.35s ease-in-out;
    }
    .itemTitle {
      font-family: "Prompt", sans-serif;
      font-weight: 400;
      font-size: 18px;
      color: #fff;
      text-align: center;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      opacity: 0;
      z-index: 2;
      transition-delay: 150ms;
      transition: opacity 0.45s ease-in-out;
    }
    .gatsby-image-wrapper {
      width: 100%;
      height: auto;
      z-index: 1;
      transition: all 0.35s ease-in-out;
    }
  }
`

let userId = null
let canBook = true

const IndexPage = () => {
  const [num, setNum] = useState(0)
  const [courseUsers, setCourseUsers] = useState([])
  const [available, setAvailable] = useState(100)
  const [loading, setLoading] = useState(false)
  const [booking, setBooking] = useState(false)
  const [price, setPrice] = useState("")
  const [total, setTotal] = useState("")
  const isBrowser = typeof window !== "undefined"
  const courseId = "lSrOWg4ITSuc5eCR6S7f"
  const courseName = "เปิดโลก อาชีพทำเว็บไซต์"

  useEffect(() => {
    let isMounted = true
    async function fetchCollection() {
      const objRef = firebase.firestore().collection("courses").doc(courseId)
      if (objRef) {
        const doc = await objRef.get()
        const data = doc.data()
        if (data && data.users) {
          const people = data.users.length
          setNum(people)
          setCourseUsers(data.users)
          const total = parseInt(available) - parseInt(people)
          setAvailable(total)
          setLoading(true)
          if (userId) {
            const result = data.users.filter(u => u.id === userId)
            if (result && result.length > 0) {
              canBook = false
            }
          }
          let normalPrice = 0
          if (people <= 9) {
            normalPrice = 1200
          } else if (people >= 10 && people <= 49) {
            normalPrice = 2800
          } else if (people >= 50 && people <= 99) {
            normalPrice = 3900
          } else {
            normalPrice = 5800
          }
          setPrice(normalPrice)
          setTotal(numberWithCommas(normalPrice))
        }
      }
    }

    if (isMounted && isBrowser && firebase) {
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          userId = user.uid
        } else {
          localStorage.removeItem("firebaseLMSUser")
          canBook = true
        }
        fetchCollection()
      })
    }
    return () => {
      isMounted = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firebase])

  async function fetchCollectionOut() {
    const objRef = firebase.firestore().collection("courses").doc(courseId)
    if (objRef) {
      const doc = await objRef.get()
      const data = doc.data()
      if (data && data.users) {
        const people = data.users.length
        setNum(people)
        setCourseUsers(data.users)
        let normalPrice = 0
        if (people <= 9) {
          normalPrice = 1200
        } else if (people >= 10 && people <= 49) {
          normalPrice = 2800
        } else if (people >= 50 && people <= 99) {
          normalPrice = 3900
        } else {
          normalPrice = 5800
        }
        setPrice(normalPrice)
        setTotal(numberWithCommas(normalPrice))
      }
    }
  }

  const handleBooking = async () => {
    setBooking(true)
    if (userId && isBrowser) {
      await fetchCollectionOut()
      const numBook = parseInt(num) + 1
      let optionText = ""
      if (num <= 9) {
        optionText = "สำหรับผู้จอง 10 คนแรก - เข้าเรียนซ้ำได้ 3 เดือน"
      } else if (num >= 10 && num <= 49) {
        optionText = "สำหรับผู้จอง คนที่ 11-50 - เข้าเรียนซ้ำได้ 3 เดือน"
      } else if (num >= 50 && num <= 99) {
        optionText = "สำหรับผู้จอง คนที่ 51-100 - เข้าเรียนซ้ำได้ 3 เดือน"
      } else {
        optionText = "สำหรับผู้จอง คนที่ 101 ขึ้นไป - เข้าเรียนซ้ำได้ 3 เดือน"
      }
      const data = {
        id: userId,
        num: numBook,
        price: numberWithCommas(price) + " บาท",
        option: optionText,
        total: total + " บาท",
      }
      courseUsers.push(data)
      const courses = {
        name: courseName,
        users: courseUsers,
      }
      // Courses
      const addCourse = await firebase
        .firestore()
        .collection("courses")
        .doc(courseId)
        .set(courses)
        .then(() => {
          return true
        })
        .catch(error => {
          setBooking(false)
          console.log("error firestore collection set ", error)
          notification["error"]({
            message: error.name || error.status,
            description: error.error_description || error.message,
            duration: 0,
          })
          return false
        })
      // Booking
      if (addCourse) {
        const bookingData = {
          uid: userId,
          courseId: courseId,
          courseName: courseName,
          num: numBook,
          total: total + " บาท",
          pay: false,
          creationTime: firebase.firestore.Timestamp.now(),
        }
        await firebase
          .firestore()
          .collection("booking")
          .add(bookingData)
          .then(() => {
            navigate("/thank-you", {
              state: {
                courseId: courseId,
              },
            })
            notification["success"]({
              message: "ยินดีด้วยครับ",
              description: "คุณได้จองคอร์สสำเร็จแล้ว",
              duration: 0,
            })
          })
          .catch(error => {
            setBooking(false)
            console.log("error firestore collection set ", error)
            notification["error"]({
              message: error.name || error.status,
              description: error.error_description || error.message,
              duration: 0,
            })
          })
      }
    } else {
      navigate("/auth/signin", {
        state: {
          booking: true,
          courseId: courseId,
          courseName: courseName,
        },
      })
    }
  }

  return (
    <Layout>
      <Seo
        title={`สอนทำเว็บไซต์ WordPress คอร์สที่เน้นให้คุณทำเว็บที่สวยมาก ๆ ได้ ด้วยตัวคุณคนเดียว`}
        description={`คอร์สออนไลน์สอนทำเว็บไซต์ WordPress เรียนแล้วต้องได้ผลลัพธ์เป็นเว็บที่สวยมาก ๆ ที่ทำมันออกมาได้ด้วยตัวคุณเอง`}
      />
      <Logo />
      <PageContainer>
        <div className="gb--container">
          <Row>
            <Col span={24}>
              <div className="heroContent">
                <h2 className="title">
                  สอนเน้นไปที่
                  <br />
                  การทำให้คุณสามารถทำเว็บ
                  <br className="gb--visible--sm" />
                  ได้สวย จนคุณคาดไม่ถึง !
                </h2>
                <h2 className="text">คอร์ส WordPress is Beautiful</h2>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              {loading ? (
                <div className="progressWrapper">
                  {num < 100 ? (
                    <p>
                      มีผู้สนใจแล้ว {num} คน ต้องการอีก {available} คน
                    </p>
                  ) : (
                    <p>มีผู้สนใจ {num} คนแล้ว รีบจองสิทธิ์ก่อนปิดรับสมัคร</p>
                  )}
                  <Progress
                    percent={num}
                    strokeWidth={40}
                    strokeColor="#FC1A58"
                    showInfo={true}
                    format={percent => `${percent} คน`}
                  />
                </div>
              ) : (
                <Spin />
              )}
            </Col>
          </Row>
          <div className="imageTop">
            <StaticImage
              src="../../static/images/img-top.jpeg"
              alt="สอนทำเว็บไซต์ WordPress"
              placeholder="blurred"
              layout="fullWidth"
            />
          </div>
        </div>
        <div className="gb--container">
          <Row>
            <Col span={24}>
              <div className="courseWrapper">
                <h1>สอนทำเว็บไซต์ WordPress</h1>
                <h3>
                  เรียนแล้วต้องได้ผลลัพธ์เป็นเว็บ{" "}
                  <br className="gb--visible--sm" />
                  สวยมาก ๆ ที่ทำมันออกมา
                  <br className="gb--visible--sm" />
                  ได้ด้วยตัวคุณเอง
                </h3>
                <h4>
                  สอนให้คุณทำได้เองในทุกขั้นตอน ตั้งแต่ต้นจนจบ ด้วยตัวคนเดียว
                  ไม่ต้องพึ่งคนอื่น
                </h4>
              </div>
            </Col>
            <Col span={24}>
              <div className="courseDetails">
                <h4 className="title">
                  ประสบการณ์กับ WordPress <br className="gb--visible--sm" />
                  และที่มาที่ไปของคอร์สนี้
                </h4>
                <br />
                <br />
                <p className="text">
                  ย้อนไปเมื่อ 15 ปีที่แล้ว
                  <br />
                  เราเริ่มต้นกับงานทำเว็บไซต์กันสองสามคน แบบกระท่อนกระแท่น
                  พอมีงานเข้ามาก็ไม่สามารถทำให้มันออกมาสวยและดูโปรได้เลย
                  เพราะไม่ได้เป็น Designer หรือ Developer แต่อย่างใดเลยครับ
                  เป็นแค่คนธรรมดาที่ชอบทำเว็บเท่านั้นเอง ออกแบบก็ไม่เป็น
                  เขียนโค้ดก็ฝึกเอาเองได้นิดหน่อย แบบอนุบาลมาก ๆ
                </p>
                <p className="text">
                  แต่ละงานกว่าจะเสร็จก็ใช้เวลานานมาก และเว็บก็ไม่สวยเอาเสียเลย
                  แต่ตอนนั้นเอาตัวรอดกันมาได้เพราะคิดราคากันแบบถูกมาก ๆ ครับ
                  แน่นอนว่าขาดทุนแทบทุกงาน และงานก็ไม่เป็นที่น่าพอใจเลย !
                  ทั้งฝั่งเราและลูกค้า
                </p>
                <h4 className="title">จุดพลิกผัน</h4>
                <p className="text">
                  จุดพลิกในชีวิตการทำงานเกิดขึ้นเมื่อเรามาเจอกับ WordPress
                  เมื่อสัก 12 ปีที่แล้ว (ในยุคที่เริ่มมี Theme ขายกันแล้ว
                  ตอนนั้นในไทยยังรู้จัก WordPress กันน้อยมาก)
                  เราลองนำมันมาทำเป็นเว็บของตัวเอง และเริ่มลองทำให้กับลูกค้า
                </p>
                <p className="text1">ปรากฎว่ามันได้ผลดีมาก ๆ ครับ !</p>
                <p className="text">
                  อะไรที่เคยเป็นปัญหา เช่นการทำเว็บออกมาแล้วดูไม่สวย ดูไม่เก่ง
                  ใช้เวลาทำนาน ก็ถูกแก้ไขปัญหาให้ได้หมดเลย ถึงแม้ช่วงแรก ๆ
                  จะยังจับจุดกันไม่ค่อยถูก แต่พอทำออกมา
                  ก็ได้งานที่เกินความคาดหมายไปมาก และลูกค้าก็ชอบมากด้วย
                </p>
                <h4 className="title">พอจับจุดได้เท่านั้นแหละ !</h4>
                <p className="text">
                  เราได้ทำซ้ำกันหลายเว็บมากขึ้น (ทำกันหลักร้อยเว็บ)
                  ก็เริ่มได้เทคนิคเฉพาะทาง เริ่มมีการจับทางเทคโนโลยีได้ว่า
                  อันไหนดี อันไหนไม่ดี แบบไหนไม่ควรทำ แบบไหนทำให้ง่าย
                  แบบไหนทำแล้วสวย แบบไหนลูกค้าชอบ ต้องใช้ Theme หรือ Plugin
                  ตัวไหนถึงดีและคุ้มค่าที่สุด แบบไหนที่ใช้แล้วทำเกิดปัญหาตามมา
                  และไม่ควรไปยุ่งกับมันอีก
                </p>
                <p className="text" style={{ marginBottom: "0" }}>
                  พอเริ่มจับจุดได้ จนได้เป็นชุดความรู้ที่มีค่าในการทำงาน
                </p>
                <p className="text1">
                  มันก็ทำให้เราได้ผลลัพธ์ที่ดีเกินคาด
                  และมีลูกค้าเพิ่มขึ้นเป็นจำนวนมากครับ
                </p>
                <p className="text">
                  ตอนนั้นเรามีนิสัยการทำงานหมู่คือ{" "}
                  <br className="gb--visible--sm" />
                  นอกจากการเน้นให้ได้เว็บที่สวยนำมาก่อนแล้ว การทำงานทุกชิ้น
                  จะต้องทำให้ลูกค้ารู้สึกคุ้มค่ากับเงินของเขาเสมอ
                  ซึ่งถือเป็นเรื่องสำคัญอย่างมากในข้อตกลงด้านนิสัยของพวกเรา
                </p>
                <p className="text">
                  ซึ่งเรื่องการทำงานด้านความรู้สึกที่คุ้มค่านี่แหละ
                  คือหัวใจที่ทำให้เรายกระดับการทำงานขึ้นมาในโซนตลาดบนได้
                  พอจับจุดได้ ธุรกิจของเราก็ก้าวกระโดดเป็นอย่างมากในช่วงนั้น
                  ต้องขยายทีมงานให้มากขึ้น และได้ลูกค้ารายใหญ่ ๆ
                  เข้ามามากขึ้นเรื่อย ๆ
                </p>
                <h3 className="color1">
                  คำว่า “จับจุดได้” นี่แหละครับ{" "}
                  <br className="gb--visible--sm" />
                  เป็นชุดคัมภีร์ลับของพวกเรา <br className="gb--visible--sm" />
                  ที่จะนำมาเฉลยในคอร์สนี้ <br className="gb--visible--sm" />
                  กันแบบหมดเปลือก
                </h3>
                <p className="text">
                  ตอนนี้การทำเว็บของพวกเราก็พัฒนาไปในโซนที่ใหญ่ขึ้นกว่าแต่ก่อนมากครับ
                  งานของเราข้ามเทคโนโลยีไปมากกว่า WordPress แล้ว
                  และมีโครงการทำเรื่องอื่น ๆ กันต่อ หลังจากนี้คงไม่ค่อยได้ทำ
                  WordPress กันเหมือนแต่ก่อนแล้ว
                </p>
                <h4 className="title">
                  ส่งต่อความรู้ ให้เกิดผลลัพธ์สู่ผู้อื่น
                </h4>
                <p className="text">
                  ด้วยความที่เรามองเห็นว่า
                  ชุดความรู้ที่สามารถทำให้เราประสบความสำเร็จ ในการทำงาน
                  ที่ได้ผลลัพธ์แบบจริงจัง จนยกระดับอาชีพการงาน
                  ให้เกิดขึ้นมาได้จริง จากเว็บราคาสามสี่พันบาทในยุคเริ่มต้น
                  จนทำให้เราพัฒนามาเป็นงานเว็บ หลักหลายแสนบาทได้
                  มันไม่มีทางหาชุดความรู้แบบนี้กันมาได้ง่าย ๆ
                  และมันมีค่าพอที่จะส่งต่อไปสู่ผู้คนที่สนใจ
                  เพื่อให้ได้ผลลัพธ์ใกล้เคียงแบบที่เราเคยทำได้
                  จึงเกิดโครงการนี้ขึ้นมาครับ
                </p>
                <h3 className="color2">
                  รับสมัครผู้สนใจยกระดับความสามารถใน
                  <br className="gb--visible--sm" />
                  การทำเว็บ WordPress ให้เป็นโปร{" "}
                  <br className="gb--visible--sm" />
                  จำนวน 100 คน
                </h3>
                <p className="text">
                  เราจะไม่บอกว่าคอร์สนี้ง่าย <br className="gb--visible--sm" />
                  เราจะไม่บอกคุณว่าใช้เวลาไม่กี่ชั่วโมงก็ทำเว็บได้แล้ว
                </p>
                <p className="text">
                  แต่เราจะบอกว่า หากคุณได้ลองทำตามทีละขั้นตอน
                  บวกกับความพยายามของคุณที่ต้องใส่ใจกับมัน
                  เราจะพาคุณไปถึงผลลัพธ์ที่ต้องการได้โดยไม่ยาก
                  โดยเน้นให้ทำได้ด้วยตนเองทั้งหมด ไม่ต้องพึ่งคนอื่น
                  ลงรายละเอียดในทุกขั้นตอน จนคุณสามารถออนไลน์เว็บจริง ๆ ได้เอง
                </p>
                <p className="text">
                  เราต้องการทำให้ผู้เรียนรู้สึกคุ้มค่ากับเงินที่จ่ายมาเสมอ
                  ตามแนวทางการทำงานของเราที่เป็นมาโดยตลอด
                  โดยที่ผู้เรียนไม่ต้องกังวลด้านพื้นฐานความรู้ใด ๆ
                  เพราะตอนเราเริ่มต้นกับ WordPress ก็เป็นคนธรรมดาคนหนึ่งเลย
                  เมื่อเทียบกับคนอื่นในสายงานนี้
                </p>
                <p className="text">
                  หากคุณพอที่จะอ่านภาษาอังกฤษได้บ้าง มีคอมพิวเตอร์ใช้ทำงาน
                  และมีเป้าหมายในใจที่อยากทำเว็บออกมาให้สวยและมีคุณภาพที่ดีอยู่เสมอ
                  เท่านี้ก็เพียงพอแล้วครับ (แต่หากใครมีพื้นฐานการออกแบบ
                  หรือการโค้ด คุณก็จะจับจุดในส่วนที่ถนัดได้เร็วขึ้น
                  และทำออกมาให้มีจุดเด่นในแบบของคุณเองได้มากกว่าคนอื่น)
                </p>
                <p className="text">
                  ถ้าสนใจมาร่วมเป็นผู้เริ่มต้นกับเรา
                  เพื่อให้โครงการนี้เกิดขึ้นมาได้จริง เราต้องการสมาชิก 100
                  คนในการเริ่มต้นครับ
                  และแน่นอนว่าผู้เริ่มต้นจะถือเป็นส่วนสำคัญอย่างมากของโปรเจคนี้
                  เรามีสิทธิพิเศษต่าง ๆ ที่เตรียมไว้มอบให้อย่างมากมายแน่นอนครับ
                </p>
              </div>
            </Col>
          </Row>
          <PortfolioWrapper>
            <Row>
              <Col xs={24}>
                <p className="title">ผลงานของทีมผู้สอน</p>
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={12}>
                <div className="portfolioItem">
                  <a
                    href="https://capitalread.co/"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <div className="overlay"></div>
                    <h3 className="itemTitle">Capital</h3>
                    <StaticImage
                      src="../../static/images/portfolio-1.png"
                      alt="Capital"
                      placeholder="blurred"
                      layout="fullWidth"
                      aspectRatio={16 / 9}
                    />
                  </a>
                </div>
              </Col>
              <Col xs={24} sm={12}>
                <div className="portfolioItem">
                  <a
                    href="https://www.vejthani.com/"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <div className="overlay"></div>
                    <h3 className="itemTitle">Vejthani Hospital</h3>
                    <StaticImage
                      src="../../static/images/portfolio-2.png"
                      alt="Vejthani Hospital"
                      placeholder="blurred"
                      layout="fullWidth"
                      aspectRatio={16 / 9}
                    />
                  </a>
                </div>
              </Col>
              <Col xs={24} sm={12}>
                <div className="portfolioItem">
                  <a
                    href="https://doichaangcoffee.co.th/"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <div className="overlay"></div>
                    <h3 className="itemTitle">Doichaang Coffee</h3>
                    <StaticImage
                      src="../../static/images/portfolio-3.png"
                      alt="Doichaang Coffee"
                      placeholder="blurred"
                      layout="fullWidth"
                      aspectRatio={16 / 9}
                    />
                  </a>
                </div>
              </Col>
              <Col xs={24} sm={12}>
                <div className="portfolioItem">
                  <a
                    href="https://www.doremialigner.com/"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <div className="overlay"></div>
                    <h3 className="itemTitle">Doremi Clear Aligners</h3>
                    <StaticImage
                      src="../../static/images/portfolio-4.png"
                      alt="Doremi Clear Aligners"
                      placeholder="blurred"
                      layout="fullWidth"
                      aspectRatio={16 / 9}
                    />
                  </a>
                </div>
              </Col>
              <Col xs={24} sm={12}>
                <div className="portfolioItem">
                  <a
                    href="https://www.thaioutdoorgroup.com/"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <div className="overlay"></div>
                    <h3 className="itemTitle">Thai Outdoor Group</h3>
                    <StaticImage
                      src="../../static/images/portfolio-5.png"
                      alt="Thai Outdoor Group"
                      placeholder="blurred"
                      layout="fullWidth"
                      aspectRatio={16 / 9}
                    />
                  </a>
                </div>
              </Col>
              <Col xs={24} sm={12}>
                <div className="portfolioItem">
                  <a
                    href="https://ohlinsasia.com/"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <div className="overlay"></div>
                    <h3 className="itemTitle">Öhlins Asia</h3>
                    <StaticImage
                      src="../../static/images/portfolio-6.png"
                      alt="Öhlins Asia"
                      placeholder="blurred"
                      layout="fullWidth"
                      aspectRatio={16 / 9}
                    />
                  </a>
                </div>
              </Col>
            </Row>
          </PortfolioWrapper>
          <Row>
            <Col span={24}>
              <div className="backgroundWrapper">
                <p className="title">โปรเจคการสอนนี้จัดทำโดยทีม WebsiteCafe</p>
                <p className="text">
                  ในการดูแลของ Deeboon Ltd.,Part.{" "}
                  <br className="gb--visible--sm" />
                  ทีมที่เติบโตมาจากการใช้ WordPress ในการทำงาน{" "}
                  <br className="gb--visible--sm" />
                  ปัจจุบันรับงานทำเว็บที่ราคาหลักหลายแสนบาท{" "}
                  <br className="gb--visible--sm" />
                  และดูแลงานให้กับลูกค้าธุรกิจรายใหญ่หลายราย{" "}
                  <br className="gb--visible--sm" />
                  รู้จักกับเราให้มากยิ่งขึ้นได้ที่นี่ครับ
                  <a
                    className="link"
                    href="https://websitecafe.co/"
                    target="_blank"
                    rel="noopener"
                  >
                    websitecafe.co
                  </a>
                </p>
                <p className="text" style={{ marginBottom: "0" }}>
                  หลักสูตรสอนทำเว็บไซต์ WordPress{" "}
                  <br className="gb--visible--sm" />
                  ทำขึ้นด้วยทีมงานของเราหลายคน ในรูปแบบคอร์สออนไลน์{" "}
                  <br className="gb--visible--sm" />
                  สอนด้วยวีดีโอและอีบุ๊ค สามารถเรียนย้อนหลังได้
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <div className="courseDetails">
                <h4 className="title">
                  คำเตือน
                  <br />
                  จะมีค่าใช้จ่ายเพิ่มในการซื้อเครื่องมือ
                </h4>
                <p className="text">
                  คอร์สนี้ไม่เหมาะกับผู้ทดลองเรียน{" "}
                  <br className="gb--visible--sm" />
                  เนื่องจากคอร์สนี้เน้นการสอนเพื่อให้ผู้เรียนทำเว็บไซต์ได้ในระดับโปรและต้องสวยแบบเอาจริงเอาจัง
                  เป็นคอร์สที่เข้มข้นจนถึงขั้นสามารถรับงานเองได้เลย
                  ผู้เรียนจึงจำเป็นต้องมีการลงทุนในค่าใช้จ่ายที่เกี่ยวกับการ
                  ซื้อ Theme ซื้อรูป ซื้อโดเมน ซื้อโฮสติ้ง ด้วยตนเอง
                  เพราะจะสอนการ setup เรื่องพวกนี้ในหลักสูตรด้วย
                </p>
                <p className="text">
                  จะใช้เงินซื้อเครื่องมือเหล่านี้อีกประมาณ สามพันบาท
                  ซึ่งเป็นค่าใช้จ่ายที่ไม่เกี่ยวข้องกับค่าเรียน
                  จะมีการซื้อหลังจากได้คำแนะนำจากในคอร์สแล้ว
                  (ไม่ควรซื้อก่อนเรียน เดี๋ยวซื้อผิด !)
                  และไม่ใช่การแอบแฝงขายของจากพวกเราอย่างแน่นอน
                  โดยผู้เรียนจะต้องซื้อด้วยตัวเองจากเว็บไซต์ต่างประเทศ
                  โดยในการสอนจะบอกวิธีซื้อเหล่านี้ในทุกขั้นตอนครับ
                </p>
              </div>
            </Col>
          </Row>
          <div className="imageBottom">
            <StaticImage
              src="../../static/images/img-bottom.jpeg"
              alt="สอนทำเว็บไซต์ WordPress"
              placeholder="blurred"
              layout="fullWidth"
            />
          </div>
          <Row>
            <Col span={24}>
              <div className="courseDetails">
                <h4 className="title">คอร์ส WordPress is Beautiful</h4>
                <p className="text">
                  สอนทำเว็บไซต์ WordPress โดยการใช้ Theme{" "}
                  <br className="gb--visible--sm" />
                  เน้นผลลัพธ์ ให้ผู้เรียนจบต้องทำเว็บสวย ๆ ได้{" "}
                  <br className="gb--visible--sm" />
                  ตั้งแต่ต้นจนสามารถนำเว็บขึ้นออนไลน์ได้ ด้วยตัวเองคนเดียว{" "}
                  <br className="gb--visible--sm" />
                  ค่าเรียน 5,800 บาท เรียนย้อนหลังได้ 3 เดือน
                </p>
                <h4 className="title" style={{ marginBottom: "40px" }}>
                  ราคาพิเศษสำหรับสมาชิก 100 คนแรก
                </h4>
                <p className="special">
                  สำหรับ 10 คนแรก ราคา <span>1,200-.</span>
                </p>
                <p className="special">
                  คนที่ 11 ถึง 50 ราคา <span>2,800-.</span>
                </p>
                <p className="special">
                  คนที่ 51 ถึง 100 ราคา <span>3,900-.</span>
                </p>
                <p className="special">
                  คนที่ 101 ขึ้นไป ราคา <span>5,800-.</span>
                </p>
                <br />
                <br />
                <h3 className="color2">
                  จองวันนี้ !<br />
                  รับของขวัญพิเศษทันทีมูลค่า 7 พันบาท{" "}
                  <br className="gb--visible--sm" />
                  สำหรับผู้จอง 100 คนแรกเท่านั้น
                </h3>
                <p className="gift">ของขวัญชิ้นที่ 1</p>
                <p className="gift">
                  รับฟรี คอร์ส Avada WordPress Theme มูลค่า 3,500 บาท ฟรี
                </p>
                <p className="text">
                  สอนการใช้งาน Theme WordPress ที่ชื่อว่า Avada อย่างละเอียด
                  ทำให้คุณสามารถทำเว็บออกมาได้สวย หลากหลายสไตล์
                </p>
                <p className="gift">ของขวัญชิ้นที่ 2</p>
                <p className="gift">
                  รับฟรี คอร์ส Bridge WordPress Theme มูลค่า 3,500 บาท ฟรี
                </p>
                <p className="text">
                  สอนการใช้งาน Theme WordPress ที่ชื่อว่า Bridge อย่างละเอียด
                  ทำให้คุณสามารถทำเว็บแนว creative
                  ที่สวยหลากหลายมากยิ่งขึ้นไปอีก
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              {loading ? (
                <div className="progressWrapper">
                  {num < 100 ? (
                    <p>
                      มีผู้สนใจแล้ว {num} คน ต้องการอีก {available} คน
                    </p>
                  ) : (
                    <p>มีผู้สนใจ {num} คนแล้ว รีบจองสิทธิ์ก่อนปิดรับสมัคร</p>
                  )}
                  <Progress
                    percent={num}
                    strokeWidth={40}
                    strokeColor="#FC1A58"
                    showInfo={true}
                    format={percent => `${percent} คน`}
                  />
                </div>
              ) : (
                <Spin />
              )}
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <div className="itemWrapper">
                {num <= 9 ? (
                  <div className="enabled">
                    <p className="price">
                      <strike>12,800</strike> <span>1,200</span>บาท
                    </p>
                    <p>สามารถเข้าเรียนซ้ำได้ 3 เดือน</p>
                    <p className="hilight">
                      ราคานี้ สำหรับผู้จอง 10 คนแรกเท่านั้น
                    </p>
                    <p>
                      สิ่งที่จะได้รับ
                      <br />
                      คอร์ส WordPress is Beautiful มูลค่า 5,800-.
                      <br />
                      คอร์ส Avada WordPress Theme มูลค่า 3,500-.
                      <br />
                      คอร์ส Bridge WordPress Theme มูลค่า 3,500-.
                    </p>
                    <p>
                      ตอนนี้เท่านั้น ! ที่คุณจะได้รับถึง 3 คอร์ส{" "}
                      <br className="gb--hidden gb--visible--sm" />
                      มูลค่า <strike>12,800</strike> บาท แต่จ่ายเพียงแค่ 1,200
                      บาท
                    </p>
                  </div>
                ) : num >= 10 && num <= 49 ? (
                  <div className="enabled">
                    <p className="price">
                      <strike>12,800</strike> <span>2,800</span>บาท
                    </p>
                    <p>สามารถเข้าเรียนซ้ำได้ 3 เดือน</p>
                    <p className="hilight">
                      ราคานี้ สำหรับผู้ที่จองคนที่ 11-50 เท่านั้น
                    </p>
                    <p>
                      สิ่งที่จะได้รับ
                      <br />
                      คอร์ส WordPress is Beautiful มูลค่า 5,800-.
                      <br />
                      คอร์ส Avada WordPress Theme มูลค่า 3,500-.
                      <br />
                      คอร์ส Bridge WordPress Theme มูลค่า 3,500-.
                    </p>
                    <p>
                      ตอนนี้เท่านั้น ! ที่คุณจะได้รับถึง 3 คอร์ส{" "}
                      <br className="gb--hidden gb--visible--sm" />
                      มูลค่า <strike>12,800</strike> บาท แต่จ่ายเพียงแค่ 2,800
                      บาท
                    </p>
                  </div>
                ) : num >= 50 && num <= 99 ? (
                  <div className="enabled">
                    <p className="price">
                      <strike>12,800</strike> <span>3,900</span>บาท
                    </p>
                    <p>สามารถเข้าเรียนซ้ำได้ 3 เดือน</p>
                    <p className="hilight">
                      ราคานี้ สำหรับผู้ที่จองคนที่ 51-100 เท่านั้น
                    </p>
                    <p>
                      สิ่งที่จะได้รับ
                      <br />
                      คอร์ส WordPress is Beautiful มูลค่า 5,800-.
                      <br />
                      คอร์ส Avada WordPress Theme มูลค่า 3,500-.
                      <br />
                      คอร์ส Bridge WordPress Theme มูลค่า 3,500-.
                    </p>
                    <p>
                      ตอนนี้เท่านั้น ! ที่คุณจะได้รับถึง 3 คอร์ส{" "}
                      <br className="gb--hidden gb--visible--sm" />
                      มูลค่า <strike>12,800</strike> บาท แต่จ่ายเพียงแค่ 3,900
                      บาท
                    </p>
                  </div>
                ) : (
                  <div className="enabled">
                    <p className="price">
                      <strike>12,800</strike> <span>5,800</span>บาท
                    </p>
                    <p className="hilight">เข้าเรียนซ้ำได้ 3 เดือน</p>
                    <p>
                      สิ่งที่จะได้รับ
                      <br />
                      คอร์ส WordPress is Beautiful มูลค่า 5,800-.
                      <br />
                      คอร์ส Avada WordPress Theme มูลค่า 3,500-.
                      <br />
                      คอร์ส Bridge WordPress Theme มูลค่า 3,500-.
                    </p>
                    <p>
                      ตอนนี้เท่านั้น ! ที่คุณจะได้รับถึง 3 คอร์ส{" "}
                      <br className="gb--hidden gb--visible--sm" />
                      มูลค่า <strike>12,800</strike> บาท แต่จ่ายเพียงแค่ 5,800
                      บาท
                    </p>
                  </div>
                )}
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              {canBook ? (
                <Button
                  type="primary"
                  className="linkButton"
                  loading={booking}
                  disabled={booking}
                  onClick={handleBooking}
                >
                  จองคอร์สนี้
                </Button>
              ) : (
                <ButtonColor
                  text="รายละเอียดการจองคอร์สนี้"
                  cta="/backend/booking"
                />
              )}
            </Col>
          </Row>
        </div>
      </PageContainer>
    </Layout>
  )
}

export default IndexPage
